import { GeolocationPermissionStates } from 'utils/geolocation';

export type OnLocationPermissionChange = (permission: GeolocationPermissionStates) => void;
export type UseUpdateOnLocationPermissionChange = (callback: OnLocationPermissionChange) => void;
